module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAyMCAzMyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDIpIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxyZWN0IHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSIyIiB3aWR0aD0iMTYiIGhlaWdodD0iMjkiIHJ4PSI4Ii8+PHJlY3QgZmlsbD0iI0ZGRiIgeD0iNiIgeT0iNCIgd2lkdGg9IjQiIGhlaWdodD0iNyIgcng9IjIiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollDown/mouse.svg
// module id = 415
// module chunks = 0